import React, {useEffect, useState} from "react";

import { Input } from "reactstrap";
import {InputType} from "reactstrap/types/lib/Input";

interface InputTextProps {
  value: null | string;
  id: string;
  placeholder: null | string;
  onChange: (value: string|number) => void;
  required: false | boolean;
  maxLength: null | number;
  className: null | string;
  autoFocus: false | boolean;
  addon: string;
  type?: InputType;
}
const InputTextAddon = ({ id, placeholder, value, onChange, required, maxLength, className, autoFocus, addon, type = 'text'}: InputTextProps) => {

    const [text, setText] = useState<string|number>(value || '');

    useEffect(() => {
        setText(value);
    }, [value]);

    const onChangeText = (text:string|number) => {
        setText(text);
        onChange(text);
    }

    return (
      <div className="input-group">
          <span className="input-group-text" id="product-price-addon">{addon}</span>
        <Input
        type={type}
        className={className || "form-control"}
        id={ id }
        placeholder={placeholder || ""}
        value={text || ''}
        onChange={(e: any) => {
            onChangeText(e.target.value);
        }}
        maxLength={maxLength || null}
        autoComplete="off"
        required={ required }
        autoFocus={autoFocus}
      />
      </div>
  );
};
export default InputTextAddon;
